import { gettext } from '~/i18n/catalog'

const PERIOD_OPTIONS = [
  { label: gettext('1 week'), id: 7 },
  { label: gettext('1 month'), id: 30 },
  { label: gettext('3 months'), id: 90 },
  { label: gettext('1 year'), id: 365 },
]

export const buyOrderOptions = PERIOD_OPTIONS

export const sellOrderOptions = PERIOD_OPTIONS
